module.exports = __webpack_public_path__ + "static/media/file-code.8d6d792c.svg";